import React from 'react';
import { ParticipantHubLayout } from './ParticipantHubLayout';
import { motion } from 'framer-motion';
import { MapPinIcon, ClockIcon, CoffeeIcon, UtensilsIcon, MoonIcon, WifiIcon, PhoneIcon } from 'lucide-react';
export function ArrivalBriefingPage() {
  return <ParticipantHubLayout data-id="element-4528">
      <div className="p-6 lg:p-8 max-w-5xl mx-auto space-y-8" data-id="element-4529">
        <div data-id="element-4530">
          <h1 className="font-serif-display text-4xl text-slate-900 mb-2" data-id="element-4531">
            Arrival Briefing
          </h1>
          <p className="text-slate-500" data-id="element-4532">
            Your guide to Day 1 at the Moon Palace Cancún.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-4533">
          {/* Timeline */}
          <div className="lg:col-span-2 space-y-6" data-id="element-4534">
            <h2 className="font-serif-display text-2xl text-slate-900 mb-4" data-id="element-4535">
              Day 1 Timeline
            </h2>
            <div className="relative border-l-2 border-slate-200 ml-4 space-y-8 pb-4" data-id="element-4536">
              {[{
              time: '2:00 PM',
              title: 'Arrival & Check-in',
              location: 'Main Lobby',
              desc: 'Proceed to the dedicated Finova Capital check-in desk. Your room keys and welcome kit will be waiting.',
              icon: MapPinIcon
            }, {
              time: '3:00 PM - 5:00 PM',
              title: 'Free Time & Settle In',
              location: 'Resort Grounds',
              desc: 'Take time to unpack, explore the property, or relax by the pool before the evening program begins.',
              icon: CoffeeIcon
            }, {
              time: '6:00 PM',
              title: 'Welcome Reception',
              location: 'Ocean Terrace',
              desc: 'Join the leadership team for sunset cocktails and light hors d’oeuvres.',
              icon: UtensilsIcon
            }, {
              time: '7:30 PM',
              title: 'Opening Dinner & Keynote',
              location: 'Grand Ballroom',
              desc: 'Opening remarks by CEO Marcus Chen, followed by a three-course dinner.',
              icon: MoonIcon
            }].map((event, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: i * 0.1
            }} className="relative pl-8" data-id="element-4537">
                  <div className="absolute -left-[21px] top-1 w-10 h-10 rounded-full bg-white border-2 border-amber-500 flex items-center justify-center shadow-sm" data-id="element-4538">
                    <event.icon className="w-4 h-4 text-amber-600" data-id="element-4539" />
                  </div>
                  <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm hover:shadow-md transition-shadow" data-id="element-4540">
                    <div className="flex items-center gap-2 text-sm font-bold text-amber-600 mb-1" data-id="element-4541">
                      <ClockIcon className="w-4 h-4" data-id="element-4542" />
                      {event.time}
                    </div>
                    <h3 className="font-bold text-lg text-slate-900 mb-1" data-id="element-4543">
                      {event.title}
                    </h3>
                    <div className="flex items-center gap-1 text-sm text-slate-500 mb-3" data-id="element-4544">
                      <MapPinIcon className="w-3.5 h-3.5" data-id="element-4545" />
                      {event.location}
                    </div>
                    <p className="text-slate-600 text-sm" data-id="element-4546">{event.desc}</p>
                  </div>
                </motion.div>)}
            </div>
          </div>

          {/* Sidebar */}
          <div className="space-y-6" data-id="element-4547">
            {/* Venue Overview */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="bg-white rounded-2xl border border-slate-200 overflow-hidden shadow-sm" data-id="element-4548">
              <div className="h-40 overflow-hidden" data-id="element-4549">
                <img src="https://images.unsplash.com/photo-1582719478250-c894e4dc240e?auto=format&fit=crop&w=800&q=80" alt="Resort" className="w-full h-full object-cover" data-id="element-4550" />
              </div>
              <div className="p-6" data-id="element-4551">
                <h3 className="font-serif-display text-xl text-slate-900 mb-4" data-id="element-4552">
                  Moon Palace Cancún
                </h3>
                <div className="space-y-3" data-id="element-4553">
                  <div className="flex items-center gap-3 text-sm text-slate-600" data-id="element-4554">
                    <WifiIcon className="w-4 h-4 text-amber-500" data-id="element-4555" />
                    Network: FinovaSummit / Pass: Summit2026
                  </div>
                  <div className="flex items-center gap-3 text-sm text-slate-600" data-id="element-4556">
                    <MapPinIcon className="w-4 h-4 text-amber-500" data-id="element-4557" />
                    Sessions in the South Wing
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Your Hosts */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm" data-id="element-4558">
              <h3 className="font-serif-display text-xl text-slate-900 mb-4" data-id="element-4559">
                Your Support Team
              </h3>
              <div className="space-y-4" data-id="element-4560">
                <div className="flex items-center gap-3" data-id="element-4561">
                  <div className="w-10 h-10 rounded-full bg-slate-200 overflow-hidden" data-id="element-4562">
                    <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=200&q=80" alt="Host" className="w-full h-full object-cover" data-id="element-4563" />
                  </div>
                  <div data-id="element-4564">
                    <div className="text-sm font-bold text-slate-900" data-id="element-4565">
                      Amanda Torres
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-4566">
                      Lead Facilitator
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-3" data-id="element-4567">
                  <div className="w-10 h-10 rounded-full bg-slate-200 overflow-hidden" data-id="element-4568">
                    <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=200&q=80" alt="Concierge" className="w-full h-full object-cover" data-id="element-4569" />
                  </div>
                  <div data-id="element-4570">
                    <div className="text-sm font-bold text-slate-900" data-id="element-4571">
                      James Wilson
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-4572">
                      Summit Concierge
                    </div>
                  </div>
                </div>
                <button className="w-full mt-2 py-2 border border-slate-200 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors flex items-center justify-center gap-2" data-id="element-4573">
                  <PhoneIcon className="w-4 h-4" data-id="element-4574" />
                  Contact Concierge
                </button>
              </div>
            </motion.div>

            {/* Wellness */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="bg-amber-50 rounded-2xl border border-amber-100 p-6 shadow-sm" data-id="element-4575">
              <h3 className="font-serif-display text-xl text-slate-900 mb-2" data-id="element-4576">
                Wellness & Rhythm
              </h3>
              <p className="text-sm text-slate-700 mb-4" data-id="element-4577">
                To help with the time zone adjustment, we recommend a 15-minute
                walk on the beach upon arrival. The Awe Spa is also available
                for express treatments.
              </p>
              <button className="text-amber-700 text-sm font-semibold hover:text-amber-800" data-id="element-4578">
                Book Spa Treatment &rarr;
              </button>
            </motion.div>
          </div>
        </div>
      </div>
    </ParticipantHubLayout>;
}